import type { TMessages } from '@/types/TMessages'

export const messages = {
  options: {
    purchaseOfMachineryEquipment: 'Покупка техники/оборудования',
    replenishmentOfWorkingCapital: 'Пополнение оборотных средств',
    purchaseOfFixedAssets: 'Приобретение основных средств',
    purchaseOfGoodsAndMaterials: 'Приобретение ТМЦ',
    refinancingCurrentLoans: 'Рефинансирование текущих кредитов',
    businessDevelopment: 'Развитие бизнеса',
    other: 'Иные цели',
  },
  multiSelect: {
    placeholder: 'Цели кредита',
  },
  otherPurposeInput: {
    placeholder: 'Иные цели кредита',
  },
  error: {
    required: 'Необходимо заполнить',
  },
} satisfies TMessages
